export default "__VITE_ASSET__DH0dnY6s__"